import React from 'react';
import PropTypes from 'prop-types';
import LinkComponent from '@material-ui/core/Link';

const Link = ({ theme, className, children, target, href, Icon = null, testId }) => (
    <LinkComponent
        href={ href }
        target={ target }
        rel={ target === '_blank' ? 'noopener noreferrer' : null }
        className={ className }
        data-testid={ testId }
    >
        <span className={ theme.link }>
            <span>{children}</span>
            {Icon && <Icon />}
        </span>
    </LinkComponent>
);

Link.propTypes = {
    theme: PropTypes.shape({}),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    target: PropTypes.string,
    href: PropTypes.string,
    Icon: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({}),
    ]),
    className: PropTypes.string,
    testId: PropTypes.string,
};

export default Link;
